import { RouteConfig } from 'vue-router';
import CorporateCareTypeSelection from '@/apps/corporateOnboarding/careType/CorporateCareTypeSelection.vue';
import BackupCareRequest from '@/apps/corporateOnboarding/backupCare/BackupCareRequest.vue';
import { requireSeeker } from '../guards/authGuards';
import corporateOnboardingGuard from '../guards/corporateOnboardingGuard';
import combineGuards from '../guards/helpers';
import CorporateOnboardingGuided from '@/apps/corporateOnboarding/guided/CorporateOnboardingGuided.vue';
import CorporateOnboardingGuidedSelection from '@/apps/corporateOnboarding/guided/CorporateOnboardingGuidedSelection.vue';
import CorporateOnboardingGuidedLocation from '@/apps/corporateOnboarding/guided/CorporateOnboardingGuidedLocation.vue';
import CorporateOnboardingGuidedCareNearYou from '@/apps/corporateOnboarding/guided/CorporateOnboardingGuidedCareNearYou.vue';
import CorporateOnboardingGuidedCareType from '@/apps/corporateOnboarding/guided/CorporateOnboardingGuidedCareType.vue';

const corporateOnboardingGuards = combineGuards([requireSeeker, corporateOnboardingGuard]);

/**
 * Corporate Onboarding Routes
 *
 * Entry at /corporate-onboarding resolves to either care type selection or backup care continuation.
 */
export const corporateOnboardingRoutes = [
  {
    path: '/corporate-onboarding',
    name: 'corporate_onboarding',
    beforeEnter: corporateOnboardingGuards,
    redirect: '/corporate-onboarding/care-type',
  },
  {
    path: '/corporate-onboarding/care-type',
    name: 'corporate_onboarding_care_type',
    component: CorporateCareTypeSelection,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
  },
  {
    path: '/corporate-onboarding/backup-care',
    name: 'corporate_onboarding_backup_care',
    component: BackupCareRequest,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
  },
];

export const corporateOnboardingGuidedRoutes: RouteConfig[] = [
  {
    path: '/corporate-onboarding/guided',
    component: CorporateOnboardingGuided,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
    children: [
      {
        path: '',
        redirect: { name: 'corporate-onboarding-guided-selection' },
      },
      {
        path: 'selection',
        name: 'corporate-onboarding-guided-selection',
        component: CorporateOnboardingGuidedSelection,
        meta: {
          routeStepper: {
            stepLabel: 'Selection',
          },
        },
      },
      {
        path: 'location',
        name: 'corporate-onboarding-guided-location',
        component: CorporateOnboardingGuidedLocation,
        meta: {
          routeStepper: {
            stepLabel: 'Location',
            breadcrumbLabel: 'Back',
          },
        },
      },
      {
        path: 'care-near-you',
        name: 'corporate-onboarding-guided-care-near-you',
        component: CorporateOnboardingGuidedCareNearYou,
        meta: {
          routeStepper: {
            stepLabel: 'Care near you',
          },
        },
      },
      {
        path: 'care-type',
        name: 'corporate-onboarding-guided-care-type',
        component: CorporateOnboardingGuidedCareType,
        meta: {
          routeStepper: {
            stepLabel: 'Care type',
          },
        },
      },
    ],
  },
];
